var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.971191,
    width: 30,
    height: 30,
    rx: 8,
    fill: "black",
    fillOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47119 9.51638C8.47119 9.03537 8.64012 8.63855 8.97795 8.32591C9.31578 8.01325 9.75498 7.85693 10.2955 7.85693C10.8264 7.85693 11.2559 8.01084 11.5841 8.31869C11.922 8.63615 12.0909 9.0498 12.0909 9.55967C12.0909 10.0214 11.9268 10.4062 11.5986 10.7141C11.2608 11.0315 10.8168 11.1903 10.2666 11.1903H10.2521C9.72119 11.1903 9.29166 11.0315 8.96347 10.7141C8.63528 10.3966 8.47119 9.99738 8.47119 9.51638ZM8.65942 22.1426V12.5034H11.8737V22.1426H8.65942ZM13.6546 22.1426H16.8689V16.7602C16.8689 16.4235 16.9075 16.1638 16.9847 15.981C17.1198 15.6539 17.325 15.3774 17.6001 15.1513C17.8751 14.9252 18.2202 14.8122 18.6353 14.8122C19.7164 14.8122 20.2569 15.5385 20.2569 16.9911V22.1426H23.4712V16.6159C23.4712 15.1922 23.1334 14.1123 22.4577 13.3764C21.782 12.6405 20.8891 12.2725 19.7791 12.2725C18.5339 12.2725 17.5639 12.8064 16.8689 13.8742V13.9031H16.8544L16.8689 13.8742V12.5034H13.6546C13.6739 12.8112 13.6835 13.7684 13.6835 15.375C13.6835 16.9815 13.6739 19.2374 13.6546 22.1426Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedin);
export default __webpack_public_path__ + "static/media/ic_linkedin.43f2c6f0.svg";
export { ForwardRef as ReactComponent };